<div class="relative w-full h-full text-center">
  @if (mimetype() | startsWith: 'image/') {
    <nrc-image
      [source]="{ uri: source(), mimetype: mimetype() }"
      [thumbnail]="{ uri: thumbnailSource(), mimetype: mimetype() }"
      [alt]="alt()"
      [objectFit]="'contain'"
      [priority]="true"
      (loadComplete)="onMediaLoadComplete()"
    />
  } @else if (mimetype() | startsWith: 'video/') {
    <nrc-video
      [sources]="[{ uri: source(), mimetype: mimetype() }]"
      [objectFit]="'contain'"
      [autoplay]="true"
      [muted]="true"
      [controls]="false"
      [loop]="true"
      [disablePictureInPicture]="true"
      (loadComplete)="onMediaLoadComplete()"
    />
  } @else {
    <p>
      {{ 'COMPONENTS.AREAS.AREA_BACKGROUND.AREA_BACKGROUND_2D.BACKGROUND.MIMETYPE_NOT_SUPPORTED_WARNING' | translate }}
    </p>
  }

  <!-- Show a warning icon in the upper-right corner of the image, if the image does not meet the requirements. -->
  @if (!backgroundMeetsRequirements() && isEditMode) {
    <div class="absolute flex flex-col items-center w-40 h-40 top-4 right-4">
      <nrc-icon
        class="w-6 h-6 peer"
        [name]="'triangle-warning'"
        [fillColor]="'warning'"
        (clickEvent)="openAspectRatioWarningMessage()"
      />

      <nrc-tooltip
        class="w-full mt-2 transition-opacity scale-0 opacity-0 peer-hover:opacity-100 peer-hover:scale-100"
        [text]="'COMPONENTS.AREAS.AREA_BACKGROUND.AREA_BACKGROUND_2D.TOOLTIP.DOES_NOT_MEET_DIMENSIONS' | translate"
      />
    </div>
  }
</div>
